export default __webpack_public_path__ + "static/media/sport5-black.e43ac116.svg";